import { create } from "zustand";
import { devtools, persist } from "zustand/middleware";
let store = (set) => ({
  user: null,
  setUser: (user) => set(() => ({ user })),
  logout: () => set(() => ({ user: null })),
  startDate: "2024-02-12",
  endDate: "2024-03-12",
  backDate: null,
  setStartDate: (startDate) => set(() => ({ startDate })),
  setEndDate: (endDate) => set(() => ({ endDate })),
  setBackDate: (backDate) => set(() => ({ backDate })),
});
store = persist(store, { name: "prabhu" });
store = devtools(store);

const useStore = create(store);

export default useStore;
